
/**
 * The purpose of this is file is to share variables between
 * CSS and JS. E.g.
 * 	In css: $primaryColor
 * 	in JS:
 * 		let variables = require('./variables.js');
 * 		console.log(variables.primaryColor);
 *
 * Note that PostCSS does not allow you to read properties of
 * variables so values must be simple (string, numbers, ...)
 * and not objects.
 */
 module.exports = {
	screen_mobileMenu: 	  '800px',
	screen_tablet: 		  '768px',
	screen_mobile: 		  '640px',
	screen_linear: 		  '460px',
	mobileHeader_height:  '70px',
	desktopHeader_height: '144px',
	font_size:             16
};
